export default __webpack_public_path__ + "static/media/expert.1d266762.png";